import NotificationBoxDefinition from '_tradeholding/js/Classes/NotificationBox';
import notificationTemplate from '_mustache/components/notification.mustache';
import DocumentObj from '_loaders/Document';

let NotificationBox = new NotificationBoxDefinition({
    notification: notificationTemplate
});

DocumentObj.addReadyStart(function() {
    NotificationBox.init();
});

window.NotificationBox = NotificationBox;

export default NotificationBox;